export const FPS = 30
export const fontSizes = [4, 100] // min/max
export const fontWeights = [80, 150] // min/max
